import React, { useEffect, useRef, useState } from 'react'
import { useInfo } from '../../context/useInfo'
import Login from '../Login';
import NoPermissions from '../NoPermissions';
import IconLinkButton from '../../components/inputs/IconLinkButton';
import { useLoaderData } from 'react-router';
import ArticleList from '../../components/ArticleList';
import utils, { generatePlaceholderArrays, getValueFromSettled } from '../../utils';
import { useEnvironment } from '../../context/useEnv';

function Dashboard() {
  const { isClient } = useEnvironment();
  const { info, fetchWeb } = useInfo();
  if (info == null) return <></>

  const { promises, data } = useLoaderData<{
    promises?: Promise<PromiseSettledResult<any>[]>,
    data?: PromiseSettledResult<any>[]
  }>();

  const [localDrafts, setLocalDrafts] = useState<null | Record<string, any>[]>(null)

  const [latestArticles, setLatestArticles] = useState(data ? getValueFromSettled(data[0]) : null);
  const [drafts, setDrafts] = useState(data ? getValueFromSettled(data[1]) : null);
  const [guides, setGuides] = useState(data ? getValueFromSettled(data[2]) : null);
  const [tags, setTags] = useState<Record<string, any>[] | null>(data ? getValueFromSettled(data[3]) : null);

  async function fetchData() {
    if (promises == undefined) return;
    const [articles, drafts, guides, tags] = await promises;
    setLatestArticles(getValueFromSettled(articles));
    setDrafts(getValueFromSettled(drafts));
    setGuides(getValueFromSettled(guides));
    setTags(getValueFromSettled(tags));
  }

  useEffect(() => {
    fetchData();
    setLocalDrafts(utils.parseStringJSON(localStorage.getItem("wiki-autosaves") || "null") || []);
  }, [])

  return <>
    <div>
      <img src="/images/dash_icon.png" alt="dash icon" className='inline w-16 aspect-square mr-4' />
      <h2 className='inline text-3xl font-semibold mb-2 align-middle'>Management dashboard</h2>
    </div>
    <p className='text-xl mt-2 mb-8'>Welcome @{info.username}</p>
    <div className='flex flex-wrap gap-2'>
      <IconLinkButton
        src='/images/pencil.png'
        label='Create wiki page'
        to='/dashboard/create/article'
        className='flex-grow basis-48'
      />
      <IconLinkButton
        src='/images/orange_config.png'
        label='Create category / tag'
        to='/dashboard/create/category'
        className='flex-grow basis-48'
      />
    </div>
    <hr className='my-4' />
    <section className='flex flex-wrap gap-4'>
      <article className='flex-grow basis-48'>
        <ArticleList
          label='Guides'
          right={false}
          primary={true}
          articles={(guides ? guides : generatePlaceholderArrays(2, { title: "...", article_path: "dashboard" })).map(
            (article: Record<string, any>) => ({ label: article.title, url: `/${article["article_path"]}` })
          )}
        />
        <ArticleList right={false} label='Categories' articles={(tags ? tags : generatePlaceholderArrays(5, { name: "..." })).map(
          tag => ({ label: tag.name, url: `/tag/${tag.name}` })
        )} />
      </article>
      <aside className='flex-grow basis-48'>
        <ArticleList
          label='Latest articles'
          articles={(latestArticles ? latestArticles : generatePlaceholderArrays(5, { title: "..." })).map(
            (article: any) => ({ label: article.title, url: `/${article["article_path"]}` })
          )}
        />
        <ArticleList
          label='My drafts'
          articles={(drafts ? drafts : generatePlaceholderArrays(2, { title: "..." })).map(
            (article: any) => ({ label: article.title, url: `/${article["article_path"]}` })
          )}
        />
        {localDrafts && <ArticleList
          label='Local drafts'
          articles={(localDrafts ? localDrafts : generatePlaceholderArrays(2, { title: "..." })).map(
            (article: any, index: number) => {
              console.log("Hooo")
              return { label: article.title, url: `/dashboard/create/article?autosave=${index}` }
            }
          )}
        />}
      </aside>
    </section>
  </>
}

export default Dashboard